// Hook for plan features and limits
import { useAuthStore } from '@stores/useAuthStore';
import { getPlanConfig, hasFeature, canUploadFile, type PlanType } from '@config/plans';

export const usePlan = () => {
  const { user } = useAuthStore();

  if (!user) {
  return {
    plan: 'free' as PlanType,
    config: getPlanConfig('free'),
    hasFeature: () => false,
    canUploadFile: () => ({ allowed: false, reason: 'Not authenticated' }),
    storageUsed: 0,
    storageLimit: 0,
    storagePercentage: 0,
  };
  }

  const plan = user.plan as PlanType;
  const config = getPlanConfig(plan);
  const totalStorage = config.limits.storage + (user.storageAddons || 0);
  const storagePercentage = Math.round((user.storageUsed / totalStorage) * 100);

  return {
    plan,
    config,
    hasFeature: (feature: string) => hasFeature(plan, feature),
    canUploadFile: (fileSize: number) => canUploadFile(plan, user.storageUsed, fileSize),
    storageUsed: user.storageUsed,
    storageLimit: totalStorage,
    storagePercentage,
  };
};

